$(document).ready(function(){
  $('.sliderGoldlashproduct').slick({
    slidesToShow:5,slidesToScroll:1,centerMode:true,arrows:false,responsive:[{breakpoint:1024,settings:{slidesToShow:3,centerMode:true,slidesToScroll:1,arrows:false}},{breakpoint:749,settings:{slidesToShow:1,slidesToScroll:1,arrows:false,centerMode:true}}]
  })
});

$(document).ready(function(){
  $('.sliderRosebrow').slick({
    slidesToShow:5,slidesToScroll:1,centerMode:true,arrows:false,responsive:[{breakpoint:1024,settings:{slidesToShow:3,centerMode:true,slidesToScroll:1,arrows:false}},{breakpoint:749,settings:{slidesToShow:1,slidesToScroll:1,arrows:false,centerMode:true}}]
  })
});

$(document).on('click','.bottomArrowSplitter',function(e){
  e.preventDefault();
  var linkToTarget = $(this).children('a').attr('href');
  $(this).toggleClass('active');
  $(linkToTarget).toggleClass('makeItOpen').slideToggle()
})

function calcTime(city, offset) {
  d = new Date();
  utc = d.getTime() + (d.getTimezoneOffset() * 60000);
  nd = new Date(utc + (3600000*offset));
  return "The local time in " + city + " is " + nd.toLocaleString();
}
console.log(calcTime('france', '+1'));
